import { Reducer } from 'redux';
import {
  SettingsState,
  SettingsActionTypes,
  SETTINGS_INPROGRESS,
  SETTINGS_SUCCESS,
  SETTINGS_FAILURE,
  DISCLAIMER_ACKNOWLEDGED,
  DISCLAIMER_INVALIDATE_ACKNOWLEDGED,
  DISCLAIMER_PREVIOUSLY_ACKNOWLEDGED,
  DATASITEHOST_INPROGRESS,
  DATASITEHOST_SUCCESS,
  DATASITEHOST_FAILURE,
  CREATE_DATASITEHOST,
  CREATE_DATASITEHOST_SUCCESS,
  CREATE_DATASITEHOST_FAILURE,
} from './types';
import * as Bixby from '$/core';

const initialState: SettingsState = {
  isLoading: false,
  error: undefined,
  settings: undefined,
  dataSiteHosts: undefined,
  disclaimerAcknowledged: false,
};

const settingsReducer: Reducer<SettingsState> = (state = initialState, action: SettingsActionTypes): SettingsState => {
  switch (action.type) {
    case SETTINGS_INPROGRESS:
      return {
        ...state,
        isLoading: true,
        settings: undefined,
      };
    case SETTINGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        settings: action.payload as Bixby.Models.Settings,
      };
    case SETTINGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        settings: undefined,
        error: action.payload as Bixby.Models.BixbyError,
      };
    case DISCLAIMER_PREVIOUSLY_ACKNOWLEDGED:
    case DISCLAIMER_ACKNOWLEDGED:
      return { ...state, disclaimerAcknowledged: true };
    case DISCLAIMER_INVALIDATE_ACKNOWLEDGED:
      return { ...state, disclaimerAcknowledged: false };
    case DATASITEHOST_INPROGRESS:
      return {
        ...state,
        isLoading: true,
        dataSiteHosts: undefined,
      };
    case DATASITEHOST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dataSiteHosts: action.payload as Bixby.Models.DataSiteHost[],
      };
    case DATASITEHOST_FAILURE:
      return {
        ...state,
        isLoading: false,
        dataSiteHosts: undefined,
        error: action.payload as Bixby.Models.BixbyError,
      };
      case CREATE_DATASITEHOST:
        return {
          ...state,
          isLoading: true,
        };
      case CREATE_DATASITEHOST_SUCCESS:
        return {
          ...state,
          isLoading: false,
          dataSiteHosts: action.payload as Bixby.Models.DataSiteHost[],
        };
      case CREATE_DATASITEHOST_FAILURE:
        return {
          ...state,
          isLoading: false,
          error: action.payload as Bixby.Models.BixbyError,
        };
    default:
      return state;
  }
};
export default settingsReducer;
